import { IAuditoriumHistoryState } from '../interfaces';
import { CreatorHistoryService, HistoryService } from '../services/app-services';
import { Observable } from 'rxjs';

export class HistoryManager {

  private readonly _auditoriumHistoryService: CreatorHistoryService;
  private readonly _historyService = new HistoryService<IAuditoriumHistoryState>();

  public constructor() {
    this._auditoriumHistoryService = new CreatorHistoryService(this._historyService);
  }

  public addToHistory(data: {
    current: IAuditoriumHistoryState,
    previous: IAuditoriumHistoryState
  }): void {
    this._historyService.addToHistory({
      seats: data?.current?.seats || [],
      baseElements: data?.current?.baseElements || [],
      sectors: data?.current?.sectors || [],
      images: data?.current?.images || [],
      priorityShape: data?.current?.priorityShape
    }, {
      seats: data?.previous?.seats || [],
      sectors: data?.previous?.sectors || [],
      baseElements: data?.previous?.baseElements || [],
      images: data?.previous?.images || [],
      priorityShape: data?.previous?.priorityShape
    }, true);
  }

  public undo(): Observable<{
    current: IAuditoriumHistoryState,
    previous: IAuditoriumHistoryState
  }> {
    return this._auditoriumHistoryService.undo();
  }

  public redo(): Observable<{
    current: IAuditoriumHistoryState,
    previous: IAuditoriumHistoryState
  }> {
    return this._auditoriumHistoryService.redo();
  }
}
